<template>
  <v-snackbar
    v-model="show"
    :timeout="5000"
    app
    top
    right
    :color="color"
    elevation="24"
  >
    {{ $t(message) }}
  </v-snackbar>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { SET_SNACKBAR } from "../../utils/constants";
export default {
  name: "Snackbar",
  computed: {
    ...mapGetters(["showSnackbar"]),
    ...mapGetters("Axios", ["message", "color"]),
    show: {
      get() {
        return this.showSnackbar;
      },
      set(value) {
        this.setShowSnackbar(value);
      }
    }
  },
  methods: {
    ...mapMutations({
      setShowSnackbar: SET_SNACKBAR
    })
  }
};
</script>

<style></style>
